import React, { FC, useMemo } from 'react';
import { Box } from '@mui/material';
import { connect } from 'react-redux';
import { getDetailsDrawerType } from 'src/DetailsDrawer/store/detailsDrawerSlice';
import { RootState } from 'src/store';
import ReceiptsCreateContent from './ReceiptsCreateContent';

type Props = ReturnType<typeof mapStateToProps>;

const DetailsContent: FC<Props> = ({ type }) => {
  const Content = useMemo(() => {
    switch (type) {
      case 'RECEIPTS_VIEW': {
        return null;
      }
      case 'RECEIPTS_CREATE': {
        return <ReceiptsCreateContent />;
      }
      case 'REPORTS_AUTOMATIONS_VIEW': {
        return null;
      }
      case 'REPORTS_AUTOMATIONS_CREATE': {
        return null;
      }
      default: {
        return null;
      }
    }
  }, [type]);

  return (
    <Box
      display="flex"
      overflow="hidden"
      flex={1}
      // sx={{ padding: ({ spacing }) => spacing(1.5, 2.5) }}
    >
      {Content}
    </Box>
  );
};

const mapStateToProps = (state: RootState) => ({
  type: getDetailsDrawerType(state),
});

export default connect(mapStateToProps)(DetailsContent);
